'use client';

import {useContext} from 'react';

import {BaseCalendar, CalendarMode} from 'Calendar';
import {DatepickerContext} from 'Datepicker';
import {Dropdown} from 'Dropdown';

import type {BaseDatepickerProps} from 'Datepicker';
import type {BaseCalendarProps} from 'Calendar';
import type {DropdownProps} from 'Dropdown';

type CalendarProps = Pick<DropdownProps, 'targetRef'> & Pick<BaseDatepickerProps, 'calendarProps'>;

export const Calendar: React.FC<CalendarProps> = ({targetRef, calendarProps}) => {
  const {value, mode, onChange, isOpen, setIsOpen} = useContext(DatepickerContext);

  if (!isOpen) {
    return null;
  }

  const props: BaseCalendarProps = {
    viewDate: value[0],

    ...calendarProps,

    mode,
    value,

    onChange: newValue => {
      const newIsOpen = mode === CalendarMode.Range && (!newValue[0] || !newValue[1]);

      setIsOpen(newIsOpen);
      onChange(newValue);
    },
  };

  const dropdownProps = {
    isOpen,
    setIsOpen,
    targetRef,
    offset: 8,
  };

  return (
    <Dropdown {...dropdownProps}>
      <BaseCalendar {...props} />
    </Dropdown>
  );
};
